@if (button$ | async; as button) {
    @if (button.selectedPaymentType === paymentMethod.ApplePayDirect) {
        <button
            class="applePayButton apple-pay-button apple-pay-button-black w-100"
            [disabled]="button.isDisabled && !button.isProcessing"
            (click)="button.action()"></button>
    } @else {
        <button
            ds-button
            msThemedButton
            size="large"
            truncate="true"
            class="place-button"
            [kind]="button.config.kind"
            [variant]="button.config.variant"
            [themeKind]="button.config.themeKind"
            [themeVariant]="button.config.themeVariant"
            [loading]="button.isProcessing"
            [ngClass]="{
                'has-inline-message': button.message && ShowMessageInButtonEpcot(button.state),
            }"
            [disabled]="button.isDisabled && !button.isProcessing"
            (click)="button.action()">
            {{ button.title }}
            @if (button.message && (!isEpcotEnabled || ShowMessageInButtonEpcot(button.state))) {
                <span slot="subtext" class="place-button-message"> {{ button.message }} </span>
            }
            <ng-template #loadingTemplate><span class="betslip-place-button__loading"></span> {{ button.title }}</ng-template>
        </button>
    }
    @if (isEpcotEnabled && button.message && !ShowMessageInButtonEpcot(button.state)) {
        <span class="betslip-place-button__message message-bottom">
            {{ button.message }}
        </span>
    }
}
